import type { PaymentChannelCriterion } from '@festina/moneyout-general-types/moneyout'
import { notEmpty, type OptionalArray } from '@festina-life/core'
import { useTranslateEnum } from '@festina-life/ui/hooks'

type Props = {
  paymentChannelCriteria: OptionalArray<PaymentChannelCriterion>
}
export const PaymentChannelCriteria = ({ paymentChannelCriteria }: Props) => {
  const translateEnum = useTranslateEnum()

  return (
    <>
      {paymentChannelCriteria
        ?.filter(notEmpty)
        ?.map((criteria) => {
          const lifeInsuranceEvent = criteria?.lifeInsuranceEvent
            ? `(${translateEnum(
                'moneyOut.enum.LifeInsuranceEvent',
                criteria.lifeInsuranceEvent,
              )})`
            : undefined

          const outgoingPaymentType = translateEnum(
            'moneyOut.enum.OutgoingPaymentType',
            criteria?.outgoingPaymentType,
          )

          return [outgoingPaymentType, lifeInsuranceEvent]
            .filter(notEmpty)
            .join(' ')
        })
        .join(', ')}
    </>
  )
}
